import { SpPipe } from '../services/sp-pipe.service';
import {TranslateService} from "@stefanholzapfel/lit-translate";

export class LocaleDatePipe implements SpPipe {
    
    private locale;
    private showTime;
    private showTimeZone;

    constructor(locale?: string, showTime = false, showTimezone = false) {
        this.locale = locale ? locale : TranslateService.translate('LANG');
        this.showTime = showTime;
        this.showTimeZone = showTimezone;
    }

    // Takes a date object or a date from backend and outputs it as a localized string. Use timezone if you need the output in a specific one (not the browsers)
    public transform(date: string | Date, timeZone?: string, dateIsUtc = false, ): string {
        let localeDate = date as Date;
        if (typeof date === 'string') {
            localeDate = new Date(`${date}${ dateIsUtc ? '+00' : ''}`);
        }
        const config: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            ...timeZone && { timeZone },
            ...this.showTime && {
                hour: '2-digit',
                minute: '2-digit'
            },
            ...this.showTimeZone && {
                timeZoneName: 'short'
            }
        };
        return this.showTime ?
            localeDate.toLocaleTimeString(this.locale, config) :
            localeDate.toLocaleDateString(this.locale, config);
    }
    
}
